var _defs, _g, _path, _path2, _path3, _g2, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "camera-b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m222.14 390h755.71v155h-755.71z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "camera-a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m222.14 560h755.71v314h-755.71z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#camera-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m666.68 462.18c60.117 0 112.31 33.109 141.13 81.875l169.86 0.19531v-92.055c0-34.258-27.562-62.043-61.371-62.043h-632.96c-33.918 0-61.184 27.785-61.184 62.043l0.17188 91.273 303.13 0.20312c29.02-48.59 81.008-81.492 141.23-81.492"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m380.89 360.93h-56.309l-6.5078 20.52h67.492z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m888.62 349.98h-74.973l-13.305 31.648h100.44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m631.27 370.7h-64.531v-31.559h64.531zm59.156-44.238h-182.2l-37.535 55.559h254.11z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#camera-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m816.61 560.51c9.3945 20.91 14.941 43.93 14.941 68.43 0 92.047-73.832 166.76-164.87 166.76-91.152 0-164.96-74.727-164.96-166.76 0-24.5 5.4648-47.52 14.934-68.535h-294.51v251.29c0 34.059 27.266 61.848 61.184 61.848h632.96c33.812 0 61.371-27.789 61.371-61.848l0.20312-251.18z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m756.59 574.15c-2.5859-4.6484-5.8398-9.0078-9.3867-13.156-19.246-23.426-48.055-38.828-80.516-38.828-32.562 0-61.371 15.312-80.621 38.633-3.5352 4.2539-6.8008 8.6133-9.5742 13.352-9.6562 16.074-15.508 34.648-15.508 54.789 0 58.855 47.309 106.66 105.7 106.66 58.105 0 105.42-47.805 105.42-106.66-0.003907-20.133-5.75-38.707-15.52-54.789"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.905532e24f85b80b25157b6078d4ce8c.svg";
export { ForwardRef as ReactComponent };